<template>
  <div
    :style="{
      padding: '0px',
      margin: '14px',
      minHeight: '100px',
      paddingBottom: '66px',
    }"
    v-show="isShow"
  >
    <a-row :gutter="16">
      <!-- 左侧主区域 -->
      <a-col :span="16">
        <!-- 顶部统计卡片 -->
        <a-row :gutter="12" style="margin-bottom: 16px;">
          <a-col :span="6">
            <div class="stat-card" style="border-left: 3px solid #1890ff;">
              <div class="stat-icon" style="background: #e6f7ff; color: #1890ff;">
                <span>&#128722;</span>
              </div>
              <div class="stat-info">
                <div class="stat-value">{{ dashboard.totalPaidOrders || 0 }}</div>
                <div class="stat-label">已付订单总数</div>
              </div>
            </div>
          </a-col>
          <a-col :span="6">
            <div class="stat-card" style="border-left: 3px solid #52c41a;">
              <div class="stat-icon" style="background: #f6ffed; color: #52c41a;">
                <span>&#128197;</span>
              </div>
              <div class="stat-info">
                <div class="stat-value">{{ dashboard.todayOrders || 0 }}</div>
                <div class="stat-label">今日订单</div>
              </div>
            </div>
          </a-col>
          <a-col :span="6">
            <div class="stat-card" style="border-left: 3px solid #fa8c16;">
              <div class="stat-icon" style="background: #fff7e6; color: #fa8c16;">
                <span>&#128176;</span>
              </div>
              <div class="stat-info">
                <div class="stat-value">{{ dashboard.totalSales || 0 }}</div>
                <div class="stat-label">销售总额</div>
              </div>
            </div>
          </a-col>
          <a-col :span="6">
            <div class="stat-card" style="border-left: 3px solid #f5222d;">
              <div class="stat-icon" style="background: #fff1f0; color: #f5222d;">
                <span>&#128200;</span>
              </div>
              <div class="stat-info">
                <div class="stat-value">{{ dashboard.todaySales || 0 }}</div>
                <div class="stat-label">今日销售额</div>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="12" style="margin-bottom: 16px;">
          <!-- <a-col :span="6">
            <div class="stat-card" style="border-left: 3px solid #722ed1;">
              <div class="stat-icon" style="background: #f9f0ff; color: #722ed1;">
                <span>&#9200;</span>
              </div>
              <div class="stat-info">
                <div class="stat-value">{{ dashboard.pendingOrders || 0 }}</div>
                <div class="stat-label">待处理订单</div>
              </div>
            </div>
          </a-col> -->
          <a-col :span="6">
            <div class="stat-card" style="border-left: 3px solid #13c2c2;">
              <div class="stat-icon" style="background: #e6fffb; color: #13c2c2;">
                <span>&#127915;</span>
              </div>
              <div class="stat-info">
                <div class="stat-value">{{ dashboard.coinOrders || 0 }}</div>
                <div class="stat-label">代币订单</div>
              </div>
            </div>
          </a-col>
          <a-col :span="6">
            <div class="stat-card" style="border-left: 3px solid #eb2f96;">
              <div class="stat-icon" style="background: #fff0f6; color: #eb2f96;">
                <span>&#127915;</span>
              </div>
              <div class="stat-info">
                <div class="stat-value">{{ dashboard.ticketOrders || 0 }}</div>
                <div class="stat-label">门票订单</div>
              </div>
            </div>
          </a-col>
          <a-col :span="6">
            <div class="stat-card" style="border-left: 3px solid #faad14;">
              <div class="stat-icon" style="background: #fffbe6; color: #faad14;">
                <span>&#128101;</span>
              </div>
              <div class="stat-info">
                <div class="stat-value">{{ members || 0 }}</div>
                <div class="stat-label">会员总数</div>
              </div>
            </div>
          </a-col>
        </a-row>

        <!-- 趋势图 -->
        <a-row :gutter="12" style="margin-bottom: 16px;">
          <a-col :span="12">
            <div class="chart-panel">
              <p class="chart-title">近7天订单趋势</p>
              <a-divider style="margin: 12px 0;" />
              <div ref="orderChart" style="height: 280px;"></div>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="chart-panel">
              <p class="chart-title">近7天销售额趋势</p>
              <a-divider style="margin: 12px 0;" />
              <div ref="salesChart" style="height: 280px;"></div>
            </div>
          </a-col>
        </a-row>

        <a-row :gutter="12" style="margin-bottom: 16px;">
          <a-col :span="8">
            <div class="chart-panel">
              <p class="chart-title">近7天用户新增</p>
              <a-divider style="margin: 12px 0;" />
              <div ref="userChart" style="height: 280px;"></div>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="chart-panel">
              <p class="chart-title">订单状态分布</p>
              <a-divider style="margin: 12px 0;" />
              <div ref="statusChart" style="height: 320px;"></div>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="chart-panel">
              <p class="chart-title">订单类型分布</p>
              <a-divider style="margin: 12px 0;" />
              <div ref="typeChart" style="height: 320px;"></div>
            </div>
          </a-col>
        </a-row>
      </a-col>

      <!-- 右侧栏 -->
      <a-col :span="8">
        <div class="sidebar-card zhanneixin">
          <h1 style="font-size: 16px">站内信</h1>
          <a-divider />
          <a-modal v-model="visible" title="消息" @ok="handleOk">
            <p>{{ mes }}</p>
          </a-modal>
          <a-table
            @change="handleTableChange"
            :columns="columns"
            :data-source="msgData"
            :showHeader="false"
            :pagination="pagination"
            :loading="loading"
          >
            <template slot="messageType" slot-scope="text, messageType">
              <a-tag
                @click="message(messageType)"
                v-if="messageType.readed === true"
                color="#87d068"
              >
                已读
              </a-tag>
              <a-tag v-else color="#f50" @click="message(messageType)">
                未读
              </a-tag>
            </template>
          </a-table>
        </div>
        <div class="sidebar-card xitong">
          <p class="p">系统消息</p>
          <a-divider />
          <systemInformationFormTwo></systemInformationFormTwo>
        </div>

        <div style="display: flex; align-items: center; justify-content: center; gap: 20px; margin-top: 16px;">
          <div style="text-align: center;">
            <p style="margin-bottom: 8px;" @click="downloadCodeImg">门店二维码</p>
            <img
              @click="downloadCodeImg"
              :src="img"
              alt=""
              style="width: 150px; height: 150px; cursor: pointer;"
            />
          </div>
          <div style="text-align: center;">
            <p style="margin-bottom: 8px;" @click="downloadCodeImgs">门店小程序</p>
            <img
              @click="downloadCodeImgs"
              :src="imgs"
              alt=""
              style="width: 150px; height: 150px; cursor: pointer;"
            />
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {
  storeMainLetter,
  storeMembers,
  createCode,
  createCodes,
  storeDashboard,
} from "@/api/storeApi.js";
import systemInformationFormTwo from "./systemInformationFormTwo.vue";

const columns = [
  {
    title: "ma",
    dataIndex: "messageTitle",
    scopedSlots: { customRender: "name" },
  },
  {
    dataIndex: "readed",
    scopedSlots: { customRender: "messageType" },
  },
  {
    dataIndex: "createTime",
    scopedSlots: { customRender: "createTime" },
  },
];

export default {
  components: {
    systemInformationFormTwo,
  },
  data() {
    return {
      msgData: {},
      mes: "",
      img: "",
      imgs: "",
      readed: "",
      objId: "",
      visible: false,
      columns,
      isShow: true,
      roleName: "",
      dashboard: {},
      members: "",
      charts: {},
    };
  },
  mounted() {
    // 找到父级 .main 滚动容器，用 JS 控制滚动以绕过 66px 死区
    this.$nextTick(() => {
      const mainEl = this.$el.closest(".main");
      if (mainEl) {
        this._mainEl = mainEl;
        this._wheelHandler = (e) => {
          e.preventDefault();
          const maxScroll = mainEl.scrollHeight - mainEl.clientHeight + 66;
          let newScroll = mainEl.scrollTop + e.deltaY;
          newScroll = Math.max(0, Math.min(newScroll, maxScroll));
          mainEl.scrollTop = newScroll;
        };
        mainEl.addEventListener("wheel", this._wheelHandler, { passive: false });
      }
    });
    this.getShow();
    if (this.isShow) {
      this.getDashboard();
      this.getStoreMembers();
      this.getStoreMainLetter();
      this.getCreateCode();
      this.getCreateCodes();
    }
  },
  methods: {
    getShow() {
      this.roleName = sessionStorage.getItem("roleName");
      if (this.roleName && this.roleName.includes("收银")) {
        this.isShow = false;
      } else if (sessionStorage.getItem("partnerId") === "true") {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    getDashboard() {
      storeDashboard().then((res) => {
        this.dashboard = res.data || {};
        this.$nextTick(() => {
          this.initCharts();
        });
      });
    },
    getStoreMembers() {
      storeMembers().then((res) => {
        this.members = res.data;
      });
    },
    getStoreMainLetter() {
      storeMainLetter(5, 1).then((res) => {
        this.msgData = res.data;
      });
    },
    message(row) {
      this.visible = true;
      this.mes = row.messageRecord;
      this.readed = row.readed;
      this.objId = row.objId;
    },
    handleOk() {
      this.visible = false;
    },
    downloadCodeImg() {
      var a = document.createElement("a");
      a.download = name || "pic";
      a.href = this.img;
      a.click();
    },
    downloadCodeImgs() {
      var a = document.createElement("a");
      a.download = name || "pic";
      a.href = this.imgs;
      a.click();
    },
    getCreateCode() {
      createCode().then((res) => {
        this.img = res.data;
      });
    },
    getCreateCodes() {
      createCodes().then((res) => {
        this.imgs = res.data;
      });
    },
    initCharts() {
      const d = this.dashboard;
      // 销毁旧实例
      Object.values(this.charts).forEach((c) => c && c.dispose());
      this.charts = {};

      // 订单趋势
      const orderDates = (d.orderTrend || []).map((item) => item.date.substring(5));
      const orderCounts = (d.orderTrend || []).map((item) => item.count);
      this.charts.order = echarts.init(this.$refs.orderChart);
      this.charts.order.setOption(this.buildLineOption(orderDates, orderCounts, "订单数", "#1890ff"));

      // 销售额趋势
      const salesDates = (d.salesTrend || []).map((item) => item.date.substring(5));
      const salesAmounts = (d.salesTrend || []).map((item) => item.amount);
      this.charts.sales = echarts.init(this.$refs.salesChart);
      this.charts.sales.setOption(this.buildBarOption(salesDates, salesAmounts, "销售额(元)", "#52c41a"));

      // 用户新增趋势
      const userDates = (d.userTrend || []).map((item) => item.date.substring(5));
      const userCounts = (d.userTrend || []).map((item) => item.count);
      this.charts.user = echarts.init(this.$refs.userChart);
      this.charts.user.setOption(this.buildLineOption(userDates, userCounts, "新增用户", "#722ed1"));

      // 订单状态分布
      this.charts.status = echarts.init(this.$refs.statusChart);
      this.charts.status.setOption({
        tooltip: { trigger: "item", formatter: "{b}: {c} ({d}%)" },
        animation: false,
        legend: { bottom: 5, textStyle: { fontSize: 12 }, itemGap: 12 },
        series: [
          {
            type: "pie",
            radius: ["30%", "55%"],
            center: ["50%", "45%"],
            avoidLabelOverlap: true,
            itemStyle: { borderRadius: 6, borderColor: "#fff", borderWidth: 2 },
            label: { show: true, formatter: "{b}\n{c}", fontSize: 12 },
            labelLine: { length: 12, length2: 10 },
            data: [
              { value: d.totalPaidOrders || 0, name: "已支付订单", itemStyle: { color: "#52c41a" } },
              { value: d.unpaidOrders || 0, name: "未支付订单", itemStyle: { color: "#faad14" } },
              { value: d.refundedOrders || 0, name: "已退款", itemStyle: { color: "#f5222d" } },
              { value: d.cancelledOrders || 0, name: "已取消", itemStyle: { color: "#8c8c8c" } },
            ],
          },
        ],
      });

      // 订单类型分布（代币 vs 门票）
      this.charts.type = echarts.init(this.$refs.typeChart);
      this.charts.type.setOption({
        tooltip: { trigger: "item", formatter: "{b}: {c} ({d}%)" },
        animation: false,
        legend: { bottom: 5, textStyle: { fontSize: 12 }, itemGap: 12 },
        series: [
          {
            type: "pie",
            radius: ["30%", "55%"],
            center: ["50%", "45%"],
            avoidLabelOverlap: true,
            itemStyle: { borderRadius: 6, borderColor: "#fff", borderWidth: 2 },
            label: { show: true, formatter: "{b}\n{c}", fontSize: 12 },
            labelLine: { length: 12, length2: 10 },
            data: [
              { value: d.coinOrders || 0, name: "代币订单", itemStyle: { color: "#1890ff" } },
              { value: d.ticketOrders || 0, name: "门票订单", itemStyle: { color: "#722ed1" } },
            ],
          },
        ],
      });

      // 窗口resize自适应（节流）
      if (!this._resizeBound) {
        this._resizeBound = () => {
          if (this._resizeTimer) clearTimeout(this._resizeTimer);
          this._resizeTimer = setTimeout(() => {
            this.handleResize();
          }, 150);
        };
      }
      window.removeEventListener("resize", this._resizeBound);
      window.addEventListener("resize", this._resizeBound);
    },
    handleResize() {
      Object.values(this.charts).forEach((c) => c && c.resize());
    },
    buildLineOption(dates, values, name, color) {
      return {
        animation: false,
        tooltip: { trigger: "axis" },
        grid: { left: "8%", right: "5%", bottom: "10%", top: "10%" },
        xAxis: {
          type: "category",
          data: dates,
          axisLabel: { fontSize: 11, rotate: 30 },
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
          minInterval: 1,
          axisLabel: { fontSize: 11 },
          splitLine: { lineStyle: { type: "dashed" } },
        },
        series: [
          {
            name: name,
            data: values,
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 6,
            areaStyle: {
              color: {
                type: "linear",
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: color + "40" },
                  { offset: 1, color: color + "05" },
                ],
              },
            },
            itemStyle: { color: color },
            lineStyle: { width: 2 },
          },
        ],
      };
    },
    buildBarOption(dates, values, name, color) {
      return {
        animation: false,
        tooltip: { trigger: "axis" },
        grid: { left: "10%", right: "5%", bottom: "10%", top: "10%" },
        xAxis: {
          type: "category",
          data: dates,
          axisLabel: { fontSize: 11, rotate: 30 },
        },
        yAxis: {
          type: "value",
          axisLabel: { fontSize: 11 },
          splitLine: { lineStyle: { type: "dashed" } },
        },
        series: [
          {
            name: name,
            data: values,
            type: "bar",
            barWidth: "50%",
            itemStyle: {
              color: color,
              borderRadius: [4, 4, 0, 0],
            },
          },
        ],
      };
    },
  },
  beforeDestroy() {
    if (this._mainEl && this._wheelHandler) {
      this._mainEl.removeEventListener("wheel", this._wheelHandler);
    }
    if (this._resizeBound) {
      window.removeEventListener("resize", this._resizeBound);
    }
    if (this._resizeTimer) {
      clearTimeout(this._resizeTimer);
    }
    Object.values(this.charts).forEach((c) => c && c.dispose());
  },
};
</script>

<style scoped>
.stat-card {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  padding: 14px 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s;
}
.stat-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}
.stat-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-right: 12px;
  flex-shrink: 0;
}
.stat-info {
  flex: 1;
  min-width: 0;
}
.stat-value {
  font-size: 22px;
  font-weight: 700;
  color: #262626;
  line-height: 1.2;
}
.stat-label {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 4px;
}
.chart-panel {
  background: #fff;
  border-radius: 8px;
  padding: 16px 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
.chart-panel >>> canvas {
  pointer-events: none;
}
.chart-title {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
  margin: 0 0 4px 0;
}
.sidebar-card {
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}
.zhanneixin {
  margin-bottom: 16px;
  min-height: 200px;
}
.xitong {
  min-height: 200px;
}
.p {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/homeContentTwo.vue